module.exports = __webpack_public_path__ + "img/image3.f87cc607.webp";